import React, {useState, useEffect} from "react";
import {useTranslation} from "react-i18next";
// local
import MiniSelect from "components/selects/MiniSelect";
import SignContractStatusesSelect from "./SignContractStatusesSelect";
import {VideoInstructionLink} from "components/VideoInstructionLink";
import {
  sortSignContractsSelectItems,
  signContractStatusKey,
  signContractStatusName,
} from "../constants";

const SignContractsHead = ({filterParams, statuses, clickOnSortFilter}) => {
  const {t} = useTranslation();
  const namesToStatuses = (values) => values?.map((item) => signContractStatusKey[item]);
  const statusesToName = (values) =>
    values ? values?.map((item) => signContractStatusName[item]) : statuses;

  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 220);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className={`signing-contracts-table_head ${isScrolled ? "scrolled" : ""}`}>
      <div className="signing-contracts-table_head__name df-row-center">
        <MiniSelect
          list={sortSignContractsSelectItems}
          selectedValue={filterParams?.sort}
          prefixLabel
          itemAsObject
          onChange={(value) => clickOnSortFilter("sort", value)}
          label={t("SIGN_CONTRACTS_SORT_LABEL")}
          addClass="fz-10 __uppercase __bold"
        />
        <VideoInstructionLink
          label="VIDEO_LINK_HANDYSIGN_OVERVIEW_LABEL"
          link="VIDEO_LINK_HANDYSIGN_OVERVIEW_LINK"
          addClass="ml-8"
        />
      </div>
      <div className="signing-contracts-table_head__status">
        <SignContractStatusesSelect
          list={statuses}
          multiple
          onChange={(value) => {
            clickOnSortFilter(
              "status",
              value.length === statuses.length ? null : namesToStatuses(value)
            );
          }}
          selectedValue={statusesToName(filterParams?.status)}
        />
      </div>
    </div>
  );
};

export default SignContractsHead;
